import { render, staticRenderFns } from "./DownloadNotification.vue?vue&type=template&id=5db8d554&"
import script from "./DownloadNotification.vue?vue&type=script&lang=js&"
export * from "./DownloadNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports